import apiClient from './apiClient';

// ─── Types ────────────────────────────────────────────────────────

export type AuditReportModule = 'Asset' | 'License' | 'Inventory' | 'Cloud';

export interface AuditReportEntry {
  id: string;
  module: AuditReportModule;
  timestamp: string;
  action: string;
  entityType: string;
  entityId: number | null;
  entityName: string;
  entityCode: string;
  personName: string;
  personEmail: string;
  actorName: string;
  actorEmail: string;
  reason: string;
  details: string;
}

export interface AuditReportQuery {
  module?: AuditReportModule;
  action?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export interface AuditReportResponse {
  data: AuditReportEntry[];
  total: number;
}

export interface AuditReportStats {
  total: number;
  asset: number;
  license: number;
  inventory: number;
  cloud: number;
}

// ─── Service ──────────────────────────────────────────────────────

export const auditReportService = {
  async getAll(query?: AuditReportQuery, signal?: AbortSignal): Promise<AuditReportResponse> {
    const response = await apiClient.get<AuditReportResponse>('/api/audit-report', {
      params: query,
      signal,
    });
    return response.data;
  },

  async getStats(query?: AuditReportQuery, signal?: AbortSignal): Promise<AuditReportStats> {
    const response = await apiClient.get<AuditReportStats>('/api/audit-report/stats', {
      params: query,
      signal,
    });
    return response.data;
  },

  /** Full filtered result set for CSV export — no pagination (User Story 114). */
  async exportAll(query?: AuditReportQuery): Promise<AuditReportEntry[]> {
    const response = await apiClient.get<AuditReportEntry[]>('/api/audit-report/export', {
      params: query,
    });
    return response.data;
  },
};
